import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { logout } from "../../redux/slices/userSlice";
import { logout as fbLogout } from "../../services/auth/AuthServices";
import { debugLog } from "../../functions";
import { useApplicantSession } from "../submissions/applicantSession";

const pages = [];
const settings = [
  { name: "Mi Perfil", url: "/profile" },
  { name: "Cerrar Sesión", url: "" },
];
// The public /submission pages have no Firebase Auth session and no /profile
// access, so an aspirant only gets the exit.
const applicantSettings = [{ name: "Cerrar Sesión", url: "" }];

// Fallback shown inside the Avatar when there is no picture.
const initialsOf = (fullName) => {
  const parts = String(fullName || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "";
  const first = parts[0][0];
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return `${first}${last}`.toUpperCase();
};

function Header() {
  const user = useSelector((state) => state.user.value);
  const dispatch = useDispatch();
  // Identity of the aspirant on the public /submission pages. A logged-in
  // system user always wins.
  const applicantSession = useApplicantSession();
  const applicant = user ? null : (applicantSession && applicantSession.identity) || null;

  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleLogo = () => {
    navigate("/dashboard");
  };

  const handleCloseUserMenu = (event, setting) => {
    debugLog("Option: " + event);
    debugLog("Option: " + setting);

    switch (setting.name) {
      case "Cerrar Sesión":
        if (applicant) {
          setAnchorElUser(null);
          if (applicant.onLogout) applicant.onLogout();
          break;
        }
        // logout();
        fbLogout();
        debugLog("Usuario ha cerrado sesión.");
        dispatch(logout());
        setAnchorElUser(null);
        break;
      // Aquí puedes agregar más opciones según lo requieras
      case "Mi Perfil":
        debugLog("Has seleccionado la opción Profile");
        setAnchorElUser(null);
        navigate(setting.url);
        break;
      default:
        debugLog("Opción no reconocida.");
        debugLog("Close Box: " + false);
        setAnchorElUser(null);
    }
  };
  const displayName = user
    ? `${user.name || ""} ${user.lastName || ""}`.trim()
    : (applicant && applicant.fullName) || "";
  // La razón social de la empresa a la que pertenece la sesión, para la segunda
  // línea del saludo. Sólo la traen las cuentas de tipo ENTITY.
  const companyName = (user && user.entityName) || "";
  const avatarUrl = user ? user.avatarUrl : applicant && applicant.photoUrl;
  const menuOptions = user ? settings : applicantSettings;

  const handleOption = (e, page) => {
    debugLog("page: ", page);
    //setAnchorElUser(null);
    //logoutUser();
    navigate(page.url);
  };
  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box
            sx={{
              flexGrow: 1,
              display: {
                xs: "flex",
                sm: "flex",
                md: "none",
                lg: "none",
                xl: "none",
              },
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/${process.env.REACT_APP_LOGOTIPO}`}
              alt="Logotipo"
              className="logo"
              style={{ cursor: "pointer", maxHeight: 40 }}
              onClick={handleLogo}
            />
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "flex", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page.name}
                  onClick={(event) => handleOption(event, page)}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      flexGrow: 1,
                      textAlign: "center",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {page.name}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              display: {
                xs: "none",
                sm: "none",
                md: "flex",
                lg: "flex",
                xl: "flex",
              },
              mr: 0,
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/${process.env.REACT_APP_LOGOTIPO}`}
              alt="Logotipo"
              className="logo"
              style={{ cursor: "pointer" }}
              onClick={handleLogo}
            />
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: "none", md: "none" },
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            LOGO
          </Typography>
          <Box
            sx={{
              flexGrow: 1,
              display: {
                xs: "none",
                sm: "none",
                md: "flex",
                lg: "flex",
                xl: "flex",
              },
            }}
          >
            {pages.map((page) => (
              <Button
                key={page.name}
                onClick={(event) => handleOption(event, page)}
                sx={{ my: 2, color: "white", display: "block" }}
              >
                {page.name}
              </Button>
            ))}
          </Box>

          {/* Only rendered for someone we can actually name: the public
              /submission pages otherwise showed a dangling "Hola," and an
              empty avatar. */}
          {(user || applicant) && (
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title={(user && user.userName) || displayName || ""}>
              <Box
                onClick={handleOpenUserMenu}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  cursor: "pointer",
                }}
              >
                {displayName && (
                  <Box
                    sx={{
                      color: "white",
                      display: { xs: "none", sm: "block" },
                      lineHeight: 1.2,
                      textAlign: "right",
                    }}
                  >
                    <Typography component="div" sx={{ lineHeight: 1.2 }}>
                      Hola,{" "}
                      <Box component="span" sx={{ fontWeight: "bold" }}>
                        {displayName}
                      </Box>
                    </Typography>
                    {/* Second line only for a company account: `entityName` is
                        attached by GET_USER from the entity's own record, so
                        staff — who have no entity — keep the single line they
                        have always had. */}
                    {companyName && (
                      <Typography
                        component="div"
                        variant="caption"
                        noWrap
                        sx={{ opacity: 0.85, maxWidth: 260, lineHeight: 1.2 }}
                      >
                        {companyName}
                      </Typography>
                    )}
                  </Box>
                )}
                <IconButton sx={{ p: 0 }} disableRipple>
                  <Avatar alt={displayName || undefined} src={avatarUrl || undefined}>
                    {initialsOf(displayName)}
                  </Avatar>
                </IconButton>
              </Box>
            </Tooltip>

            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {menuOptions.map((setting) => (
                <MenuItem
                  key={setting.name}
                  onClick={(event) => handleCloseUserMenu(event, setting)}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      flexGrow: 1,
                      textAlign: "center",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {setting.name}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Header;
